import { useButtonTranslations } from 'account/recurring-payment/lib/translations';
import { Button } from 'components/buttons/button';
import { ButtonMetadata, ButtonType } from 'components/buttons/button-types';

type CancelButtonProps = {
  onClick: () => void;
  meta?: ButtonMetadata;
}

const CancelButton = (props: CancelButtonProps) => {
  const { cancel } = useButtonTranslations();
  const { meta = {}, onClick } = props;

  const cancelButtonMeta: ButtonMetadata = {
    ...meta,
    name: 'cancel',
    title: cancel,
    type: ButtonType.OutlineDark,
  };

  return <Button meta={cancelButtonMeta} onClick={onClick}/>
}

export default  CancelButton;